export default {
  UPLOAD_SUCCESS: { TITLE: `Upload successful`, DESCRIPTION: `Your file has been uploaded successfully` },
  UPLOAD_FAILED: { TITLE: `Upload failed`, DESCRIPTION: `Your file could not be uploaded` }
}
